import axios from "axios";
import { fetchCQAStart, fetchCQAFailure, fetchCQASuccess, addCQAStart, addCQASuccess, updateCQAFailure, addCQAFailure, deleteCQAStart, deleteCQASuccess, deleteCQAFailure, fetchCQADescriptionStart, fetchCQADescriptionFailure, updateCQADescriptionStart, updateCQADescriptionSuccess, updateCQADescriptionFailure, fetchCQADescriptionSuccess, updateCQAStart, updateCQASuccess, fetchCqaStaffStart, fetchCqaStaffSuccess, fetchCqaStaffFailure, addCqaStaffStart, addCqaStaffSuccess, addCqaStaffFailure, deleteCqaStaffStart, deleteCqaStaffSuccess, deleteCqaStaffFailure, updateCqaStaffStart, updateCqaStaffSuccess, updateCqaStaffFailure } from "../slicer/CQASlice";


const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
    
export const fetchCQADesData = () => async (dispatch) => {
    dispatch(fetchCQAStart());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/getCQA`,
        getAuthHeaders() // Added authentication headers
      );
  
      const data = Array.isArray(response.data.data) ? response.data.data : [];
      dispatch(fetchCQASuccess(data));
    } catch (error) {
      dispatch(
        fetchCQAFailure(
          error.response?.data?.message || "Failed to fetch CQA data"
        )
      );
    }
  };



export const addCQAData = (cqaInfo) => async (dispatch) => {
  dispatch(addCQAStart()); // Set loading state

  try {
    // API Call to add CQA data
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/addCQA`,
      cqaInfo,
      getAuthHeaders() // Added authentication headers
    );

    console.log("Add CQA Response:", response.data);

    if (response.data.success) {
      // Dispatch success action with updated data
      dispatch(addCQASuccess(response.data.data)); // Use the returned data from the backend
      alert("CQA added successfully!");
    } else {
      throw new Error(response.data.message || "Failed to add CQA.");
    }
  } catch (error) {
    console.error("Error adding CQA data:", error);

    // Dispatch failure action with error message
    dispatch(
      addCQAFailure(
        error.response?.data?.message ||
          "Something went wrong while adding CQA data."
      )
    );

    // Show error alert
    alert(
      `Error adding CQA data: ${
        error.response?.data?.message || error.message || "Unknown error occurred."
      }`
    );
  }
};

export const deleteCQA = (Id) => async (dispatch) => {
  dispatch(deleteCQAStart());
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/deleteCQA/${Id}`,
      getAuthHeaders() // Added authentication headers
    );

    if (response.data.success) {
      dispatch(deleteCQASuccess(Id)); // Update state to remove the deleted item
      dispatch(fetchCQADesData()); // Refetch the news list to ensure the UI is updated
    } else {
      dispatch(deleteCQAFailure("Failed to delete news"));
    }
  } catch (error) {
    console.error("Error deleting news:", error);
    dispatch(
      deleteCQAFailure(
        error.response?.data?.message || "Failed to delete news"
      )
    );
  }
};

export const fetchCQADescriptionData = () => async (dispatch) => {
  dispatch(fetchCQADescriptionStart()); // Dispatch start action
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/getCQADesc`,
      getAuthHeaders() // Added authentication headers
    );

    // Safely extract data and validate
    const data = response?.data?.data;
    const validData = Array.isArray(data) ? data : [];

    // Dispatch success action
    dispatch(fetchCQADescriptionSuccess(validData));
  } catch (error) {
    // Handle error with proper fallback
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch CQA data";
    dispatch(fetchCQADescriptionFailure(errorMessage));
  }
};



export const updateCQADescriptionData = (id, contactInfo) => async (dispatch) => {
  dispatch(updateCQADescriptionStart()); // Start updating

  try {
    // API Call to update description
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/updateCQADesc/${id}`,
      contactInfo,
      getAuthHeaders() // Added authentication headers
    );

    console.log("Update Response:", response.data);

    // Dispatch success action with updated data
    dispatch(updateCQADescriptionSuccess(response.data));

    
  } catch (error) {
    console.error("Error updating description:", error);

    // Dispatch failure action with error message
    dispatch(
      updateCQADescriptionFailure(
        error.response?.data?.message || "Something went wrong while updating."
      )
    );

    // Show error alert
    alert(
      `Error updating description: ${
        error.response?.data?.message || error.message || "Unknown error occurred."
      }`
    );
  }
};

export const updateCQAData = (id, payload) => async (dispatch) => {
  try {
    const token = getToken(); // Get token
    const headers = {}; // Initialize headers object
    if (token) {
      headers["Authorization"] = `Bearer ${token}`; // Add Authorization if token exists
    }

    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/updateCQA/${id}`,
      payload, // FormData is passed here
      { headers } // Pass the combined headers object
    );

    // Dispatch success action
    dispatch({ type: "UPDATE_CQA_SUCCESS", payload: response.data });
    alert("CQA updated successfully!");

    // Optionally update local state in the component
    return response.data; // Return the updated data
  } catch (error) {
    console.error("Error updating CQA:", error);
    dispatch({
      type: "UPDATE_CQA_FAILURE",
      payload: error.response?.data?.message || "Something went wrong.",
    });
    throw error;
  }
};

export const fetchCqaStaffData = () => async (dispatch) => {
  dispatch(fetchCqaStaffStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/cqaStaff`,
      getAuthHeaders()
    );

    const data = Array.isArray(response.data.data) ? response.data.data : [];
    dispatch(fetchCqaStaffSuccess(data));
  } catch (error) {
    dispatch(
      fetchCqaStaffFailure(
        error.response?.data?.message || "Failed to fetch CQA staff"
      )
    );
  }
};

export const addCqaStaffData = (staffInfo) => async (dispatch) => {
  dispatch(addCqaStaffStart());

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/cqaStaff`,
      staffInfo,
      getAuthHeaders()
    );

    dispatch(addCqaStaffSuccess());
    return response.data;
  } catch (error) {
    dispatch(
      addCqaStaffFailure(
        error.response?.data?.message || "Failed to add CQA staff"
      )
    );
    throw error;
  }
};

export const deleteCqaStaffData = (id) => async (dispatch) => {
  dispatch(deleteCqaStaffStart());
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/cqaStaff/${id}`,
      getAuthHeaders()
    );
    dispatch(deleteCqaStaffSuccess(id));
  } catch (error) {
    dispatch(
      deleteCqaStaffFailure(
        error.response?.data?.message || "Failed to delete CQA staff"
      )
    );
    throw error;
  }
};

export const updateCqaStaffData = (id, staffInfo) => async (dispatch) => {
  dispatch(updateCqaStaffStart());
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/cqaStaff/${id}`,
      staffInfo,
      getAuthHeaders()
    );

    dispatch(updateCqaStaffSuccess());
    return response.data;
  } catch (error) {
    dispatch(
      updateCqaStaffFailure(
        error.response?.data?.message || "Failed to update CQA staff"
      )
    );
    throw error;
  }
};